
// "use client";

// import Link from "next/link";
// import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";
// import { FaXTwitter } from "react-icons/fa6";
// import toast from "react-hot-toast";

// // Footer subscribe handler
// const handleFooterSubscribe = async (e) => {
//     e.preventDefault();

//     const input = e.target.querySelector('input[type="email"]');
//     if (!input) return;

//     const email = input.value.trim();
//     if (!email) {
//         toast.error("Email is required");
//         return;
//     }

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
//     if (!emailRegex.test(email)) {
//         toast.error("Please enter a valid email address");
//         return;
//     }

//     try {
//         const loadingToast = toast.loading("Subscribing...");
//         const response = await fetch("/api/subscribe", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ email }),
//         });
//         toast.dismiss(loadingToast);
//         const data = await response.json();

//         if (!response.ok) {
//             toast.error(data.error || "Invalid email address. Please try again.");
//             return;
//         }

//         toast.success(data.message || "Thank you for subscribing!");
//         input.value = "";
//     } catch (err) {
//         console.error(err);
//         toast.error("Something went wrong. Please try again.");
//     }
// };

// // Social icons
// const SocialIcons = () => (
//     <div className="flex space-x-6 text-[20px] md:text-[18px] text-white mt-4  lg:justify-end ">
//         <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
//             <FaInstagram className="hover:text-gray-300 transition-colors" />
//         </a>
//         <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
//             <FaFacebookF className="hover:text-gray-300 transition-colors" />
//         </a>
//         <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
//             <FaXTwitter className="hover:text-gray-300 transition-colors" />
//         </a>

//     </div>
// );

// export default function Footer() {
//     const links = [
//         { id: 1, text: "Features", href: "/#features" },
//         { id: 2, text: "App", href: "/app" },
//         { id: 3, text: "FAQs", href: "/faqs" },
//         { id: 4, text: "Support", href: "/support" },
//         { id: 5, text: "Compare", href: "/compare" },
//     ];

//     return (
//         <>
//             <footer className="relative bg-black text-white overflow-hidden py-16 md:py-20 lg:py-24 px-6 sm:px-12 md:px-20  ">
//                 <div className="absolute inset-0 z-0">
//                     <img
//                         src="/images/Footer.jpg"
//                         alt="background mesh"
//                         className="w-full h-full object-cover opacity-20"
//                     />
//                 </div>

//                 <div className="relative z-10 ">
//                     {/* Desktop Layout */}
//                     <div className="hidden lg:flex gap-16">
//                         {/* Left Column: Logo + Text + Links */}
//                         <div className="w-1/2 flex flex-col items-start">
//                             <img src="/images/arzenlogowithtextcrop.png" alt="Zenithra Logo" className="w- h-15 mb-12" />
//                             <p className="text-[#FFF] text-[16px] md:text-base mb-6 max-w-sm ">
//                                 Arzen builds reliable automotive electronics<br /> designed to protect and empower every<br /> journey.
//                             </p>

//                             {/* Links */}
//                             <div className="flex flex-wrap gap-15 mt-12 justify-end">
//                                 {links.map(({ id, text, href }) => (
//                                     <Link key={id} href={href} className="text-[#A7A7A7] text-[14px] hover:text-gray-300 font-medium transition-colors text-base">
//                                         {text}
//                                     </Link>
//                                 ))}
//                             </div>
//                         </div>

//                         {/* Right Column: Newsletter + Social Icons */}
//                         <div className="w-1/2 mt-1 justify-end flex flex-col ">
//                             <h2 className="text-3xl xl:text-4xl font-normal leading-snug mb-[16px]">Subscribe to our Newsletter!!</h2>
//                             <p className="text-[16px] text-[#FFF] font-[Poppins] mb-[48px]">
//                                 Stay updated on Arzen products and offers.
//                             </p>
//                             <form className="w-full max-w-[500px] mb-[48px]" onSubmit={handleFooterSubscribe}>
//                                 <div className="flex overflow-hidden border bg-white border-white rounded-[15px]">
//                                     <input
//                                         type="email"
//                                         placeholder="Enter email address"
//                                         className="px-6 py-4 text-black h-16 w-full font-normal outline-none text-base xl:text-lg flex-1"
//                                     />
//                                     <button
//                                         type="submit"
//                                         className="cursor-pointer bg-[#212121] h-16 text-white px-8 font-bold transition-all whitespace-nowrap text-base xl:text-lg"
//                                     >
//                                         Subscribe
//                                     </button>
//                                 </div>
//                             </form>
//                             <SocialIcons />
//                         </div>
//                     </div>













//                     {/* Mobile Layout */}
//                     <div className="lg:hidden space-y-12 px-0">
//                         {/* Logo + Text */}
//                         <div className="flex flex-col items-start mb-6">
//                             <img src="/images/arzenlogowithtextcrop.png" alt="Zenithra Logo" className="  h-12 mb-9" />
//                             <p className="text-white text-sm md:text-base max-w-md whitespace-pre-line ">
//                                 Arzen builds reliable automotive electronics<br />
//                                 designed to protect and empower every<br />
//                                 journey.
//                             </p>
//                         </div>


//                         {/* Links */}
//                         <div className="flex flex-col  justify-start items-start gap-6 mt-12 text-left px-0">
//                             {links.map(({ id, text, href }) => (
//                                 <Link key={id} href={href} className="text-[#A7A7A7]  hover:text-gray-300 font-medium transition-colors text-base">
//                                     {text}
//                                 </Link>
//                             ))}
//                         </div>

//                         {/* Newsletter + Social Icons */}
//                         <div className="space-y-6">
//                             <h2 className="text-[20px] md:text-[32px] font-normal leading-snug mb-4">Subscribe to our Newsletter!!</h2>
//                             <p className="text-[12px] md:text-[16px] text-[#FFF] font-[Poppins] mb-6">
//                                 Be the first to get exclusive offers and latest updates.
//                             </p>
//                             <form className="w-full max-w-[450px] mb-4" onSubmit={handleFooterSubscribe}>
//                                 <div className="flex overflow-hidden border bg-white border-white rounded-[15px]">
//                                     <input
//                                         type="email"
//                                         placeholder="Enter email address"
//                                         className="px-4 py-3 text-black h-14 w-full outline-none text-sm sm:text-base flex-1"
//                                     />
//                                     <button
//                                         type="submit"
//                                         className="cursor-pointer bg-[#212121] h-14 text-white px-4 sm:px-6 font-bold transition-all whitespace-nowrap"
//                                     >
//                                         Subscribe
//                                     </button>
//                                 </div>
//                             </form>
//                             <SocialIcons />
//                         </div>
//                     </div>
//                 </div>
//             </footer>




//             <div className="bg-black text-[#A7A7A7] text-center sm:text-left text-sm py-4 border-t border-black px-6 sm:px-12 md:px-20">
//                 Zenithra {new Date().getFullYear()}. All rights reserved.
//             </div>
//         </>
//     );
// }





















// "use client";

// import Link from "next/link";
// import { FaFacebookF, FaTwitter, FaInstagram, FaFacebook, } from "react-icons/fa";
// import { FaXTwitter } from "react-icons/fa6";
// import toast from "react-hot-toast";

// // Footer subscribe handler
// const handleFooterSubscribe = async (e) => {
//     e.preventDefault();

//     const input = e.target.querySelector('input[type="email"]');
//     if (!input) return;

//     const email = input.value.trim();
//     if (!email) {
//         toast.error("Email is required");
//         return;
//     }

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
//     if (!emailRegex.test(email)) {
//         toast.error("Please enter a valid email address");
//         return;
//     }

//     try {
//         const loadingToast = toast.loading("Subscribing...");
//         const response = await fetch("/api/subscribe", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ email }),
//         });
//         toast.dismiss(loadingToast);
//         const data = await response.json();

//         if (!response.ok) {
//             toast.error(data.error || "Invalid email address. Please try again.");
//             return;
//         }

//         toast.success(data.message || "Thank you for subscribing!");
//         input.value = "";
//     } catch (err) {
//         console.error(err);
//         toast.error("Something went wrong. Please try again.");
//     }
// };

// // Social icons
// const SocialIcons = () => (
//     <div className="flex space-x-6 text-[20px] md:text-[18px] text-white mt-4  lg:justify-end lg:-translate-y-4 ">
//         <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
//             <FaInstagram className="hover:text-gray-300 transition-colors" />
//         </a>
//         <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
//             {/* <FaFacebookF className="hover:text-gray-300 transition-colors" /> */}
//             <FaFacebook className="hover:text-gray-300 transition-colors" />
//         </a>
//         <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
//             <FaXTwitter className="hover:text-gray-300 transition-colors" />
//         </a>

//     </div>
// );

// export default function Footer() {
//     const links = [
//         { id: 1, text: "Features", href: "/#features" },
//         { id: 2, text: "App", href: "/#download" },
//         { id: 5, text: "Compare", href: "/#comparison" },
//         { id: 3, text: "FAQs", href: "/#faqs" },
//         { id: 4, text: "Support", href: "/contact" },
//     ];

//     return (
//         <>
//             <footer className="relative bg-black text-white overflow-hidden py-16 md:py-20 lg:py-24 px-6 sm:px-12 md:px-20  ">
//                 <div className="absolute inset-0 z-0">
//                     <img
//                         src="/images/Footer.avif"
//                         alt="background mesh"
//                         className="w-full h-full object-cover opacity-20"
//                     />
//                 </div>

//                 <div className="relative z-10 ">
//                     {/* Desktop Layout - ADDED justify-between */}
//                     {/* <div className="hidden lg:flex justify-between gap-16"> */}
//                     <div className="hidden lg:flex justify-center xl:justify-between gap-24 2xl:gap-32 max-w-[1500px] mx-auto">

//                         {/* Left Column: Logo + Text + Links - CHANGED w-1/2 to w-fit */}
//                         <div className="w-fit flex flex-col items-start">
//                             <img src="/images/arzenlogowithtextcrop.avif" alt="Zenithra Logo" className="w- h-15 mb-12" />
//                             <p className="text-[#FFF] text-[16px] md:text-base mb-6 max-w-sm ">
//                                 Arzen builds reliable automotive electronics<br /> designed to protect and empower every<br /> journey.
//                             </p>

//                             {/* Links */}
//                             <div className="flex flex-wrap gap-15 mt-12 ">
//                                 {links.map(({ id, text, href }) => (
//                                     <Link key={id} href={href} className="text-[#A7A7A7] text-[14px] hover:text-gray-300 font-medium transition-colors text-base">
//                                         {text}
//                                     </Link>
//                                 ))}
//                             </div>
//                         </div>

//                         {/* Right Column: Newsletter + Social Icons - ADDED ml-auto, items-end, text-right, REMOVED w-1/2 and justify-end */}
//                         <div className="mt-1 flex flex-col  ml-auto">
//                             <h2 className="text-3xl xl:text-4xl font-normal leading-snug mb-[16px]">Subscribe to our Newsletter!!</h2>
//                             <p className="text-[16px] text-[#FFF] font-[Poppins] mb-[48px] text-start">
//                                 Stay updated on Arzen products and offers.
//                             </p>
//                             {/* ADDED self-end */}
//                             <form className="w-full max-w-[500px] mb-[48px] self-end" onSubmit={handleFooterSubscribe}>
//                                 <div className="flex overflow-hidden border bg-white border-white rounded-[15px]">
//                                     <input
//                                         type="email"
//                                         placeholder="Enter email address"
//                                         className="px-6 py-4 text-black h-16 w-full font-normal outline-none text-base xl:text-lg flex-1"
//                                     />
//                                     <button
//                                         type="submit"
//                                         className="cursor-pointer bg-[#212121] h-16 text-[16px] text-white px-8 font-bold transition-all whitespace-nowrap text-base xl:text-lg"
//                                     >
//                                         Subscribe
//                                     </button>
//                                 </div>
//                             </form>
//                             <SocialIcons />
//                         </div>
//                     </div>













//                     {/* Mobile Layout */}
//                     <div className="lg:hidden space-y-12 px-0">
//                         {/* Logo + Text */}
//                         <div className="flex flex-col items-start mb-6">
//                             <img src="/images/arzenlogowithtextcrop.avif" alt="Zenithra Logo" className="  h-12 mb-9" />
//                             <p className="text-white text-sm md:text-base max-w-md whitespace-pre-line ">
//                                 Arzen builds reliable automotive electronics<br />
//                                 designed to protect and empower every<br />
//                                 journey.
//                             </p>
//                         </div>


//                         {/* Links */}
//                         <div className="flex flex-col  justify-start items-start gap-6 mt-12 text-left px-0">
//                             {links.map(({ id, text, href }) => (
//                                 <Link key={id} href={href} className="text-[#A7A7A7] text-[14px] hover:text-gray-300 font-medium transition-colors text-base">
//                                     {text}
//                                 </Link>
//                             ))}
//                         </div>

//                         {/* Newsletter + Social Icons */}
//                         <div className="space-y-6">
//                             <h2 className="text-[20px] md:text-[32px] font-normal leading-snug mb-4">Subscribe to our Newsletter!!</h2>
//                             <p className="text-[12px] md:text-[16px] text-[#FFF] font-[Poppins] mb-6">
//                                 Be the first to get exclusive offers and latest updates.
//                             </p>
//                             <form className="w-full max-w-[450px] mb-4" onSubmit={handleFooterSubscribe}>
//                                 <div className="flex overflow-hidden border bg-white border-white rounded-[15px]">
//                                     <input
//                                         type="email"
//                                         placeholder="Enter email address"
//                                         className="px-4 py-3 text-black h-14 w-full outline-none text-sm sm:text-base flex-1"
//                                     />
//                                     <button
//                                         type="submit"
//                                         className="cursor-pointer bg-[#212121] h-14 text-[16px] text-white px-4 sm:px-6 font-bold transition-all whitespace-nowrap"
//                                     >
//                                         Subscribe
//                                     </button>
//                                 </div>
//                             </form>
//                             <SocialIcons />
//                         </div>
//                     </div>
//                 </div>
//             </footer>




//             <div className="bg-black text-[#A7A7A7] text-center sm:text-left text-sm py-4 border-t border-black px-6 sm:px-12 md:px-20">
//                 Zenithra {new Date().getFullYear()}. All rights reserved.
//             </div>
//         </>
//     );
// }









"use client";

import Link from "next/link";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import toast from "react-hot-toast";

// Smooth scroll handler
const handleSmoothScroll = (e, href) => {
  if (href.startsWith("/#")) {
    e.preventDefault();
    const targetId = href.replace("/#", "");
    const targetElement = document.getElementById(targetId);

    // if (targetElement) {
    //   targetElement.scrollIntoView({ behavior: "smooth" });
    // }
    if (targetElement) {
  const headerOffset = 100; // adjust based on your navbar height (e.g. 80px or 100px)
  const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
  const offsetPosition = elementPosition - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });
}

  }
};

// Footer subscribe handler
const handleFooterSubscribe = async (e) => {
  e.preventDefault();

  const input = e.target.querySelector('input[type="email"]');
  if (!input) return;

  const email = input.value.trim();
  if (!email) {
    toast.error("Email is required");
    return;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(email)) {
    toast.error("Please enter a valid email address");
    return;
  }

  try {
    const loadingToast = toast.loading("Subscribing...");
    const response = await fetch("/api/subscribe", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });
    toast.dismiss(loadingToast);
    const data = await response.json();

    if (!response.ok) {
      toast.error(data.error || "Invalid email address. Please try again.");
      return;
    }

    toast.success(data.message || "Thank you for subscribing!");
    input.value = "";
  } catch (err) {
    console.error(err);
    toast.error("Something went wrong. Please try again.");
  }
};

// Social icons
const SocialIcons = () => (
  <div className="flex space-x-6 text-[20px] md:text-[18px] text-white mt-4 lg:justify-end lg:-translate-y-4">
    <a
      href="https://instagram.com"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Instagram"
    >
      <FaInstagram className="hover:text-gray-300 transition-colors" />
    </a>
    <a
      href="https://facebook.com"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Facebook"
    >
      <FaFacebook className="hover:text-gray-300 transition-colors" />
    </a>
    <a
      href="https://twitter.com"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Twitter"
    >
      <FaXTwitter className="hover:text-gray-300 transition-colors" />
    </a>
  </div>
);

export default function Footer() {
  const links = [
    { id: 1, text: "Features", href: "/#features" },
    { id: 2, text: "App", href: "/#download" },
    { id: 3, text: "Compare", href: "/#comparison" },
    { id: 4, text: "FAQs", href: "/#faqs" },
    { id: 5, text: "Support", href: "/contact" },
  ];

  return (
    <>
      <footer className="relative bg-black text-white overflow-hidden py-16 md:py-20 lg:py-24 px-6 sm:px-12 md:px-20">
        <div className="absolute inset-0 z-0">
          <img
            src="/images/Footer.avif"
            alt="background mesh"
            className="w-full h-full object-cover opacity-20"
          />
        </div>

        <div className="relative z-10">
          {/* Desktop Layout */}
          <div className="hidden lg:flex justify-center xl:justify-between gap-24 2xl:gap-32 max-w-[1500px] mx-auto">
            {/* Left Column */}
            <div className="w-fit flex flex-col items-start">
              <img
                src="/images/arzenlogowithtextcrop.avif"
                alt="Zenithra Logo"
                className="h-15 mb-12"
              />
              <p className="text-[#FFF] text-[16px] md:text-base mb-6 max-w-sm">
                Arzen builds reliable automotive electronics
                <br /> designed to protect and empower every
                <br /> journey.
              </p>

              {/* Links */}
              <div className="flex flex-wrap gap-15 mt-12">
                {links.map(({ id, text, href }) => (
                  <Link
                    key={id}
                    href={href}
                    onClick={(e) => handleSmoothScroll(e, href)}
                    className="text-[#A7A7A7] text-[14px] hover:text-gray-300 font-medium transition-colors text-base"
                  >
                    {text}
                  </Link>
                ))}
              </div>
            </div>

            {/* Right Column */}
            <div className="mt-1 flex flex-col ml-auto">
              <h2 className="text-3xl xl:text-4xl font-normal leading-snug mb-[16px]">
                Subscribe to our Newsletter!!
              </h2>
              <p className="text-[16px] text-[#FFF] mb-[48px] text-start">
                Stay updated on Arzen products and offers.
              </p>
              <form
                className="w-full max-w-[500px] mb-[48px] self-end"
                onSubmit={handleFooterSubscribe}
              >
                <div className="flex overflow-hidden border bg-white border-white rounded-[15px]">
                  <input
                    type="email"
                    placeholder="Enter email address"
                    className="px-6 py-4 text-black h-16 w-full font-normal outline-none text-base xl:text-lg flex-1"
                  />
                  <button
                    type="submit"
                    className="cursor-pointer bg-[#212121] h-16 text-[16px] text-white px-8 font-bold transition-all whitespace-nowrap text-base xl:text-lg"
                  >
                    Subscribe
                  </button>
                </div>
              </form>
              <SocialIcons />
            </div>
          </div>

          {/* Mobile Layout */}
          <div className="lg:hidden space-y-12 px-0">
            <div className="flex flex-col items-start mb-6">
              <img
                src="/images/arzenlogowithtextcrop.avif"
                alt="Zenithra Logo"
                className="h-12 mb-9"
              />
              <p className="text-white text-sm md:text-base max-w-md whitespace-pre-line">
                Arzen builds reliable automotive electronics
                <br />
                designed to protect and empower every
                <br />
                journey.
              </p>
            </div>

            {/* Links */}
            <div className="flex flex-col justify-start items-start gap-6 mt-12 text-left px-0">
              {links.map(({ id, text, href }) => (
                <Link
                  key={id}
                  href={href}
                  onClick={(e) => handleSmoothScroll(e, href)}
                  className="text-[#A7A7A7] text-[14px] hover:text-gray-300 font-medium transition-colors text-base"
                >
                  {text}
                </Link>
              ))}
            </div>

            {/* Newsletter + Socials */}
            <div className="space-y-6">
              <h2 className="text-[20px] md:text-[32px] font-normal leading-snug mb-4">
                Subscribe to our Newsletter!!
              </h2>
              <p className="text-[12px] md:text-[16px] text-[#FFF] mb-6">
                Be the first to get exclusive offers and latest updates.
              </p>
              <form
                className="w-full max-w-[450px] mb-4"
                onSubmit={handleFooterSubscribe}
              >
                <div className="flex overflow-hidden border bg-white border-white rounded-[15px]">
                  <input
                    type="email"
                    placeholder="Enter email address"
                    className="px-4 py-3 text-black h-14 w-full outline-none text-sm sm:text-base flex-1"
                  />
                  <button
                    type="submit"
                    className="cursor-pointer bg-[#212121] h-14 text-[16px] text-white px-4 sm:px-6 font-bold transition-all whitespace-nowrap"
                  >
                    Subscribe
                  </button>
                </div>
              </form>
              <SocialIcons />
            </div>
          </div>
        </div>
      </footer>

      <div className="bg-black text-[#A7A7A7] text-center sm:text-left text-sm py-4 border-t border-black px-6 sm:px-12 md:px-20">
        Zenithra {new Date().getFullYear()}. All rights reserved.
      </div>
    </>
  );
}
